import { getFirstNonCompletedChallenge } from "@Components/game/challenges/utils";
import { AppContext, Events } from "@Context/common/general/context";
import MetricFilterTypes from "@Enums/MetricFilterTypes";
import useChallengesQuery from "@hooks/common/challenges/use-challenges-query";
import { UseCommonProgressDataReturn } from "@hooks/game/progress/use-common-progress-data";
import useI18n from "@i18n";
import { useContext, useMemo } from "react";

export interface UseVrProgressDataReturn {
  nextBootcampChallenge: any;
  isLoadingNextChallenge: boolean;
  navigateToNextChallenge: () => void;
  availableMetrics: Array<{ key: string; label: string }>;
}

export const useVrProgressData = (commonData: UseCommonProgressDataReturn): UseVrProgressDataReturn => {
  const { state } = useContext(AppContext);
  const { i18n } = useI18n();
  const { longTermMetricResults } = commonData;

  // TODO: can Bootcamp Challenges data be removed from this hook now that Bootcamp users can no longer acces the Progress page? @davidrocha9
  const { challenges, isLoading: isLoadingNextChallenge } = useChallengesQuery(
    {
      exclude_tags: !state.user.isSuperAdmin ? ["QA", "DEVELOPMENT"] : [],
      unpublished_allowed: state.user.isSuperAdmin,
      include_tags: ["BOOTCAMP"],
    },
    { enabled: commonData.isInBootcamp }
  );
  const nextBootcampChallenge = commonData.isInBootcamp ? (challenges[getFirstNonCompletedChallenge(challenges)] ?? null) : null;

  const navigateToNextChallenge = () => {
    if (nextBootcampChallenge) {
      Events.app.navigate.emit({ path: `/challenges/challenge/${nextBootcampChallenge.id}` });
    }
  };

  const availableMetrics = useMemo(
    () => [
      { key: MetricFilterTypes.BYB_IQ, label: i18n("progress.section.byb_iq") },
      ...Object.keys(longTermMetricResults || {}).map(metricKey => ({
        key: metricKey,
        label: i18n(`metric.${metricKey}.name`),
      })),
    ],
    [longTermMetricResults, i18n]
  );

  return {
    nextBootcampChallenge,
    isLoadingNextChallenge,
    navigateToNextChallenge,
    availableMetrics,
  };
};
